import fetch from 'cross-fetch';
import {
	ChangePasswordRequest,
	ChangePasswordResponse,
	ChangePasswordError,
	PasswordChangeAction,
} from './change-password';
import { sameOriginRequestPolicy } from '../actions';
import { RequiredBodyError } from '../error';
import { HTTP_STATUS_NO_CONTENT, HTTP_STATUS_BAD_REQUEST, HTTP_STATUS_UNAUTHORIZED, HTTP_STATUS_INTERNAL_SERVER_ERROR } from '../../../helpers/validation/common';

export class RemotePasswordChangeAction {
	private readonly baseUrl: string | null;

	constructor(baseUrl: string | null) {
		this.baseUrl = baseUrl;
	}

	action: PasswordChangeAction = async (
		request: ChangePasswordRequest
	): Promise<ChangePasswordResponse> => {
		const base: string = this.baseUrl || '';
		if (!request) {
			throw new RequiredBodyError();
		}

		const response: Response = await fetch(
			`${base}/api/login-hub/change-password`,
			{
				...sameOriginRequestPolicy,
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(request),
				mode: 'cors',
			}
		);

		if (response.status === HTTP_STATUS_NO_CONTENT) {
			return {
				status: HTTP_STATUS_NO_CONTENT,
			};
		}

		if (response.status === HTTP_STATUS_BAD_REQUEST || response.status === HTTP_STATUS_UNAUTHORIZED || response.status === HTTP_STATUS_INTERNAL_SERVER_ERROR) {
			try {
				const jsonResponse = await response.json();
				const errorType = jsonResponse?.error as ChangePasswordError | undefined;
				return {
					status: response.status as typeof HTTP_STATUS_BAD_REQUEST | typeof HTTP_STATUS_UNAUTHORIZED | typeof HTTP_STATUS_INTERNAL_SERVER_ERROR,
					error: errorType,
				};
			} catch (jsonError) {
				return {
					status: response.status as typeof HTTP_STATUS_BAD_REQUEST | typeof HTTP_STATUS_UNAUTHORIZED | typeof HTTP_STATUS_INTERNAL_SERVER_ERROR,
				};
			}
		}

		return {
			status: response.status as typeof HTTP_STATUS_BAD_REQUEST | typeof HTTP_STATUS_UNAUTHORIZED | typeof HTTP_STATUS_INTERNAL_SERVER_ERROR,
		};
	};
}
